import type {Criterion, CriterionField, Matcher} from '../criteria.types';
import {isUndefined} from 'shared/utils/custom-utils';

export default class TextCriterion implements Criterion {
    public value: { extension: string; row: string };

    constructor(public field: CriterionField, matcher?, startsWith?) {
        this.value = {
            extension: startsWith === 'wholeStartsWith' ? startsWith
                : (isUndefined(startsWith) || startsWith ? 'startsWith' : 'equals'),
            row: matcher ? matcher.value : ''
        };
    }

    public clear() {
        this.value.row = '';
    }

    public isEmpty() {
        return !this.value.row;
    }

    public toMatcher(): Matcher {
        if (this.value.extension === 'startsWith') {
            return {
                startsWithWords: {
                    value: this.value.row
                }
            };
        } else if (this.value.extension === 'wholeStartsWith') {
            return {
                wholeStartsWith: {
                    value: this.value.row
                }
            };
        } else if (this.value.extension === 'equals') {
            return {
                eq: {
                    value: this.value.row
                }
            };
        } else {
            return {
                eqWords: {
                    value: this.value.row
                }
            };
        }
    }
}
